import { render, staticRenderFns } from "./NewHighlightsInputSection.vue?vue&type=template&id=04d24b02&scoped=true"
import script from "./NewHighlightsInputSection.vue?vue&type=script&lang=ts"
export * from "./NewHighlightsInputSection.vue?vue&type=script&lang=ts"
import style0 from "./NewHighlightsInputSection.vue?vue&type=style&index=0&id=04d24b02&prod&lang=scss&scoped=true"
import style1 from "./NewHighlightsInputSection.vue?vue&type=style&index=1&id=04d24b02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d24b02",
  null
  
)

export default component.exports